import React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import AdminSection from './AdminSection';


const SetUpAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const org = location.state?.organization;


  return (
    <div className='min-h-screen min-w-screen p-8 dashboard-element-bg'>
      <motion.div 
          className='dashboard-main-color rounded-3xl w-full p-8 mt-20'
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut"
          }}
        >
        <div className="flex flex-col">
        <div className="border-b border-gray-700 pb-4 mb-4">
            <motion.h1 
              className="text-3xl font-bold text-white"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ 
                duration: 1.5,
                ease: "easeOut"
              }}
            >
              Add your Admin Users
            </motion.h1>
          </div>
          <div className="dashboard-element-bg rounded-lg p-8">
            <div className="w-full">
              <motion.p 
                className="text-xl text-white mb-24"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  duration: 0.8,
                  delay: 0.5,
                  ease: "easeOut"
                }}
              >
                Almost done! On the JoltChat app, only admin users will be able to create new groups and communites for your ministry. Add your admin users here. Don't worry, you can always add more later!
              </motion.p>              
                           <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  duration: 0.8,
                  delay: 0.8,
                  ease: "easeOut"
                }}
              >
                <AdminSection organization={org} />;
                                <div className="flex justify-center mt-10">
                  <motion.button
                    className="px-8 py-4 bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2 font-semibold text-lg"
                    onClick={() => navigate('/dashboard')}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 1.2 }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <span>Go to Dashboard</span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                    </svg>
                  </motion.button>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default SetUpAdmin;